import React from "react";

const Spacer = ({
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  children,
  paddingTop,
  paddingBottom,
  height,
  className,
}) => {
  return (
    <div
      className={className}
      style={{
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        paddingTop,
        paddingBottom,
        height,
      }}
    >
      {children}
    </div>
  );
};

export default Spacer;
